import classNames from 'classnames';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { BrandS } from '@sorare/core/src/atoms/typography';
import { css } from '@sorare/css';

const root = css`
  position: relative;
  opacity: 0;

  &.show {
    opacity: 1;

    &::after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
      opacity: 0;
      background: var(--c-nd-500);
      filter: blur(12px);
    }
  }
`;

type Props = { show: boolean; message: MessageDescriptor };
export const NewCardTag = ({ show, message }: Props) => {
  return (
    <div className={classNames(root, { show })}>
      <BrandS>
        <FormattedMessage {...message} />
      </BrandS>
    </div>
  );
};
